import { render, staticRenderFns } from "./UrbanDictionarySlider.vue?vue&type=template&id=47d95439"
import script from "./UrbanDictionarySlider.vue?vue&type=script&lang=js"
export * from "./UrbanDictionarySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports